import { render, staticRenderFns } from "./AdministratorsDetails.vue?vue&type=template&id=5edfda45&"
import script from "./AdministratorsDetails.vue?vue&type=script&lang=js&"
export * from "./AdministratorsDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorsDetails.vue?vue&type=style&index=0&id=5edfda45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports